import { apifetch } from '../services/interceptors';

// Shown when the server reports Stripe billing is off (503). The old fallback opened a
// GoHighLevel page at pipsqueaknetscan.com/pipsqueak-pro-purchase, which no longer exists
// (the marketing site was rebuilt), so every upgrade click landed on "Not Found".
const BILLING_OFF_MESSAGE =
  'Online checkout for Pipsqueak Pro is not available right now. ' +
  'Please contact helpdesk@btsg.io to upgrade your account.';

// Start the Pipsqueak Pro purchase. Behaviour depends on platform billing config:
//  • Stripe configured + enabled in Global Admin → redirect to native Stripe Checkout.
//  • Stripe NOT configured/enabled → backend returns 503; tell the user how to upgrade.
//  • Anything else (network error, unexpected 5xx, malformed response, etc.) → show an
//    error and stop.
// Resolves true when the browser is being sent to Stripe, false otherwise.
export async function startProCheckout() {
  try {
    const token = localStorage.getItem('token');
    const res = await apifetch('s1/api/billing/create-checkout-session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      }
    });

    if (res.status === 503) {
      if (typeof window !== 'undefined' && window.alert) window.alert(BILLING_OFF_MESSAGE);
      return false;
    }

    const data = await res.json().catch(() => ({}));
    if (res.ok && data && data.url) {
      window.location.href = data.url; // native Stripe-hosted checkout
      return true;
    }

    // The server puts Stripe's own reason in `details` (e.g. "No such price") — show it,
    // since "Failed to start checkout" alone gives the admin nothing to act on.
    const msg = data && data.error
      ? (data.details ? `${data.error}: ${data.details}` : data.error)
      : 'Unable to start checkout right now. Please try again later.';
    if (typeof window !== 'undefined' && window.alert) window.alert(msg);
    return false;
  } catch (err) {
    console.error('[billing] checkout request failed:', err);
    if (typeof window !== 'undefined' && window.alert) {
      window.alert('Unable to start checkout right now. Please check your connection and try again.');
    }
    return false;
  }
}

// Open the Stripe billing portal so the tenant can manage/cancel the subscription or
// update their card. Returns false if there is no billing account / portal yet.
export async function openBillingPortal() {
  try {
    const token = localStorage.getItem('token');
    const res = await apifetch('s1/api/billing/create-portal-session', {
      method: 'POST',
      headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) }
    });
    if (res.ok) {
      const data = await res.json();
      if (data && data.url) {
        window.location.href = data.url;
        return true;
      }
    }
  } catch (err) {
    console.error('[billing] portal failed:', err);
  }
  return false;
}
